import axios from "axios";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import PhoneInput from "components/common/PhoneInput";
import { selectCustomStyles } from "components/common/Select";
import { Trash2Icon } from "lucide-react";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AsyncPaginate } from "react-select-async-paginate";
import Api from "services/api";
import { fetchLanguages } from "slices/languageSlice";
import { fetchTypes } from "slices/typeSlice";
import Swal from "sweetalert2";
import { Select } from 'components/common/Select';

const AddTranslatoinForm = ({ item }) => {
  console.log("itemlan", item);
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const isEdit = location.pathname.includes("/translation/edit/");
  const isCopy = location.pathname.includes("/translation/copy/");
  const [translationRecord, setTranslationRecord] = useState(null);
  const onSubmit = async (data) => {
    setIsloading(true);
    const formData = new FormData();
    formData.append("account_id", data.account_id ?? null);
    formData.append("sub_account_id", data.sub_account_id ?? null);
    formData.append("department_id", data.department_id ?? null);
    formData.append("requester_email", data.requester_email ?? "");
    formData.append("requester_name", data.requester_name ?? "");
    formData.append("requester_phone", data.requester_phone ?? "");
    formData.append("due_date", data.due_date ?? null);
    formData.append("comment", data.comment ?? "");
    formData.append("notes", data.notes ?? "");
    formData.append("subject_matter", data.subject_matter ?? "");
    formData.append("current_phase", data.current_phase ?? "");
    formData.append("formatting", data.formatting ? 1 : 0);
    formData.append("rush", data.rush ? 1 : 0);
    formData.append("temple_recommend", data.temple_recommend ? 1 : 0);
    formData.append("church_translation", data.church_translation ? 1 : 0);
    formData.append("custom_pricing", data.custom_pricing ? 1 : 0);
    formData.append("custom_pricing_translation_rate", data.custom_pricing_translation_rate ?? 0);
    formData.append("custom_pricing_editing_rate", data.custom_pricing_editing_rate ?? 0);
    formData.append("custom_pricing_dtp_rate", data.custom_pricing_dtp_rate ?? 0);
    formData.append("custom_pricing_review_rate", data.custom_pricing_review_rate ?? 0);
    formData.append("custom_pricing_audio_recording_rate", data.custom_pricing_audio_recording_rate ?? 0);
    formData.append("custom_pricing_transcription_rate", data.custom_pricing_transcription_rate ?? 0);
    // formData.append("word_count", data.word_count ?? "");
    // formData.append("page_count", data.page_count ?? "");
    // formData.append("audio_minutes", data.audio_minutes ?? "");

    // Append target_languages as target_languages[0], target_languages[1], ...
    if (Array.isArray(data.target_languages)) {
      data.target_languages.forEach((id, idx) => {
        formData.append(`target_languages[${idx}]`, id ?? null);
      });
    } else if (data.target_languages) {
      formData.append("target_languages[0]", data.target_languages ?? null);
    }

    // Append source_language_id as a single value (not array)
    if (
      Array.isArray(data.source_language_id) &&
      data.source_language_id.length > 0
    ) {
      formData.append("source_language_id", data.source_language_id[0] ?? null);
    } else if (data.source_language_id) {
      formData.append("source_language_id", data.source_language_id ?? null);
    }

    // Append files as files[0][file] and files[0][password]
    if (Array.isArray(data.files)) {
      data.files.forEach((file, idx) => {
        formData.append(`files[${idx}][file]`, file);
        if (filePasswords && filePasswords[idx]) {
          formData.append(`files[${idx}][password]`, filePasswords[idx]);
        } else {
          formData.append(`files[${idx}][password]`, "");
        }
      });
    }

    // console.log("data", data);
    try {
      let response;
      if(isEdit){
        response = await Api?.updateTranslation(formData , id);
      }else{
        response = await Api?.submitTranslation(formData);
      }
      if (response.status === 200) {
        // console.log("Submission successful!", response);
        // toast.success(response?.data?.message);
        toast.success(response?.data?.message, {
          className: "successToast",
        });
        Swal.fire({
          title: "Success!",
          text: response?.data?.message,
          icon: "success",
        }).then(() => {
          navigate(`/translation/view/${response?.data?.data?.id}`);
        });
      }
    } catch (error) {
      console.error("Submission failed:", error);

      const backendMessage =
        error?.response?.data?.message || 
        error?.data?.message ||          
        error?.message ||               
        "An unexpected error occurred."; 
      toast.error(backendMessage, {
        className: "errorToast",
      });
      setIsloading(false)

    }
  };

  useEffect(() => {
    if (!id) {
      return;
    }

    const fetchTranslationRecord = async () => {
      setIsloading(true);
      try {
        const response = await Api.fetchTranslationById(id);
        const data = response?.data?.data ?? response?.data;
        setTranslationRecord(data || null);
      } catch (error) {
        console.error("Unable to fetch translation record", error);
        toast.error("Unable to load translation record");
      } finally {
        setIsloading(false);
      }
    };

    fetchTranslationRecord();
  }, [id]);

  // Drag and drop state
  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm();
  const dispatch = useDispatch();
  const [dragActive, setDragActive] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [filePasswords, setFilePasswords] = useState({});
  const inputRef = useRef(null);
  const selectedClientId = watch("account_id");
  const selectedTargetLanguages = watch("target_languages");
  const customPricingEnabled = watch("custom_pricing") === 1 || watch("custom_pricing") === true;

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleBrowseClick = () => {
    inputRef.current.click();
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      console.log("updated", updated);
      setValue("files", updated);
      return updated;
    });
    setFilePasswords((prev) => {
      const newPwds = { ...prev };
      delete newPwds[index];
      return newPwds;
    });
  };

  const handlePasswordChange = (index, value) => {
    setFilePasswords((prev) => ({ ...prev, [index]: value }));
  };

  // #region Language dropdown
  const [languageState, setLanguageState] = useState([]);

  useEffect(() => {
    setLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
    console.log("lan", item?.language);
  }, [item?.languages]);

  const [sourcelanguageState, setSourceLanguageState] = useState([]);

  useEffect(() => {
    setSourceLanguageState(
      item?.languages?.map((val) => ({
        label: val?.language?.name || "",
        value: val?.language?.id || "",
      }))
    );
  }, [item?.languages]);

  const filteredLanguagesLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchLanguages(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );
    return {
      options: result?.data?.map((language) => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  //#region Client dropdown
  const [filterClients, setfilterClients] = useState({
    label: "",
    value: "",
  });
  const [subAccountOptions, setSubAccountOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [templeRecommendLocked, setTempleRecommendLocked] = useState(false);
  console.log('subAccountOptionssssss', subAccountOptions);

  useEffect(() => {
    if (item?.accounts?.user?.name && item?.accounts?.user?.id) {
      setfilterClients({
        label: item?.accounts?.user?.name || "",
        value: item?.accounts?.user?.id || "",
      });
      setDepartmentOptions(mapDepartmentsToOptions(item?.accounts?.departments || []));
    } else {
      setfilterClients(null);
      setDepartmentOptions([]);
    }
  }, [item?.accounts?.user]);

  const mapSubAccountsToOptions = (subAccounts = []) =>
    (subAccounts || []).map((subAccount) => ({
      label: subAccount?.name || subAccount?.subaccount_name || "",
      value: subAccount?.id,
    }));

  const mapDepartmentsToOptions = (departments = []) =>
    (departments || []).map((department) => ({
      label: department?.name || department?.department_name || "",
      value: department?.id,
    }));

  const filteredClientsLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchTypes(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
          type:'translation',
        },
        true,
        true
      )
    );
    return {
      options: result.data.map((val) => ({
        value: val.id,
        label: val.name,
        filters: val.filters,
        data: val,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  // useEffect(() => {
  //   if (!customPricingEnabled || !selectedClientId) {
  //     return;
  //   }

  //   const fetchClientPricing = async () => {
  //     try {
  //       const response = await Api.fetchSingleType(selectedClientId);
  //       const clientData = response?.data?.data ?? response?.data;
  //       const targetLanguageId = Array.isArray(selectedTargetLanguages)
  //         ? selectedTargetLanguages.find(Boolean)
  //         : selectedTargetLanguages;

  //       const matchedCustomTier = (clientData?.custom_translation_tiers || []).find((tier) =>
  //         (tier?.languages || []).some((language) => Number(language?.language_id) === Number(targetLanguageId))
  //       );

  //       const preferredTier = matchedCustomTier || (clientData?.translation_rates || [])[0] || null;
  //       const fallbackValues = {
  //         custom_pricing_translation_rate: preferredTier?.translation_rate ?? "",
  //         custom_pricing_editing_rate: preferredTier?.editing_rate ?? "",
  //         custom_pricing_dtp_rate: preferredTier?.dtp_rate ?? "",
  //         custom_pricing_review_rate: preferredTier?.review_rate ?? "",
  //         custom_pricing_audio_recording_rate: preferredTier?.audio_recording_rate ?? "",
  //         custom_pricing_transcription_rate: preferredTier?.transcription_rate ?? "",
  //       };

  //       Object.entries(fallbackValues).forEach(([fieldName, value]) => {
  //         setValue(fieldName, value);
  //       });
  //     } catch (error) {
  //       console.error("Unable to load client translation rates", error);
  //     }
  //   };

  //   fetchClientPricing();
  // }, [customPricingEnabled, selectedClientId, selectedTargetLanguages, setValue]);

  useEffect(() => {
    if (id) return;
    if (!customPricingEnabled || !selectedClientId) {
      return;
    }

    const targetLanguageIds = Array.isArray(selectedTargetLanguages)
      ? selectedTargetLanguages.filter(Boolean)
      : selectedTargetLanguages
      ? [selectedTargetLanguages]
      : [];

    if (targetLanguageIds.length === 0) {
      return;
    }

    const fetchClientPricing = async () => {
      try {
        const response = await Api.fetchTranslationPricing(selectedClientId, targetLanguageIds);
        const totals = response?.data?.data?.totals ?? {};

        const fallbackValues = {
          custom_pricing_translation_rate: totals.translation_rate ?? "",
          custom_pricing_editing_rate: totals.editing_rate ?? "",
          custom_pricing_dtp_rate: totals.dtp_rate ?? "",
          custom_pricing_review_rate: totals.review_rate ?? "",
          custom_pricing_audio_recording_rate: totals.audio_recording_rate ?? "",
          custom_pricing_transcription_rate: totals.transcription_rate ?? "",
        };

        Object.entries(fallbackValues).forEach(([fieldName, value]) => {
          setValue(fieldName, value);
        });
      } catch (error) {
        console.error("Unable to load client translation rates", error);
      }
    };

    fetchClientPricing();
  }, [customPricingEnabled, selectedClientId, selectedTargetLanguages, setValue]);


  
  useEffect(() => {
    if (!translationRecord) {
      return;
    }

    const toBoolean = (value) => value === true || value === 1 || value === "1";
    const details = translationRecord?.translation_details || {};

    // Client (account)
    const accountId = translationRecord?.account_id || translationRecord?.accounts?.id || null;
    if (accountId) {
      setfilterClients({
        label: translationRecord?.accounts?.user?.name || "",
        value: accountId,
      });
      setSubAccountOptions(mapSubAccountsToOptions(translationRecord?.accounts?.sub_accounts || []));
      setDepartmentOptions(mapDepartmentsToOptions(translationRecord?.accounts?.departments || []));
      setValue("account_id", accountId);
    }

    const subAccountId = translationRecord?.sub_account_id || translationRecord?.subclient_id || null;
    if (subAccountId) {
      setValue("sub_account_id", subAccountId);
    }

    const departmentId = translationRecord?.translation_details?.department_id || translationRecord?.department?.id || null;
    if (departmentId) {
      setValue("department_id", departmentId);
    }

    // Source Language
    if (translationRecord?.language) {
      setSourceLanguageState({
        label: translationRecord.language.name || "",
        value: translationRecord.language.id || "",
      });
      setValue("source_language_id", translationRecord.language.id || null);
    }

    // Target Languages
    const targetLangs = Array.isArray(translationRecord?.translation_target_languages)
      ? translationRecord.translation_target_languages
          .map((val) => ({
            label: val?.language?.name || "",
            value: val?.language?.id || val?.language_id || "",
          }))
          .filter((opt) => opt.value)
      : [];

    if (targetLangs.length > 0) {
      setLanguageState(targetLangs);
      setValue(
        "target_languages",
        targetLangs.map((opt) => opt.value)
      );
    }

    // Requester info
    setValue("requester_name", translationRecord?.requester_name || "");
    setValue("requester_email", details?.requester_email || "");
    setValue("requester_phone", details?.requester_phone || "");
    setValue("due_date", details?.due_date || "");
    setValue("comment", details?.comment || "");
    setValue("notes", details?.notes || "");
    setValue("subject_matter", details?.subject_matter || translationRecord?.subject_matter || "");
    setValue("current_phase", details?.current_phase || translationRecord?.current_phase || "");

    // Checkboxes
    setValue("formatting", toBoolean(details?.formatting));
    setValue("rush", toBoolean(details?.rush));
    setValue("temple_recommend", toBoolean(details?.temple_recommend));
    setValue("church_translation", toBoolean(details?.church_translation));
    setValue("custom_pricing", toBoolean(details?.custom_pricing));
    // setValue("word_count", details?.word_count || "");
    // setValue("page_count", details?.page_count || "");
    // setValue("audio_minutes", details?.audio_minutes || "");

    // Custom pricing
    const customPricingRateValues = {
      custom_pricing_translation_rate: translationRecord?.custom_pricing?.translation_rate ?? details?.custom_pricing_translation_rate ?? null,
      custom_pricing_editing_rate: translationRecord?.custom_pricing?.editing_rate ?? details?.custom_pricing_editing_rate ?? null,
      custom_pricing_dtp_rate: translationRecord?.custom_pricing?.dtp_rate ?? details?.custom_pricing_dtp_rate ?? null,
      custom_pricing_review_rate: translationRecord?.custom_pricing?.review_rate ?? details?.custom_pricing_review_rate ?? null,
      custom_pricing_audio_recording_rate: translationRecord?.custom_pricing?.audio_recording_rate ?? details?.custom_pricing_audio_recording_rate ?? null,
      custom_pricing_transcription_rate: translationRecord?.custom_pricing?.transcription_rate ?? details?.custom_pricing_transcription_rate ?? null,
    };

    const hasCustomPricingRates = Object.values(customPricingRateValues).some(
      (val) => val !== null && val !== undefined && val !== ""
    );

    if (hasCustomPricingRates) {
      Object.entries(customPricingRateValues).forEach(([fieldName, value]) => {
        setValue(fieldName, value ?? "");
      });
    }
  }, [translationRecord, setValue]);

  const phaseOptions = [
    { label: "Translation", value: "translation" },
    { label: "Editing", value: "editing" },
    { label: "Review", value: "review" },
    { label: "Audio Recording", value: "audio_recording" },
    { label: "Transcription", value: "transcription" },
    { label: "Other", value: "other" },
  ];

  return (
    <div
      className="translation content"
      style={{
        maxWidth: 900,
        minWidth: 700,
        background: "#fff",
        marginBottom: 40,
        marginTop: 110,
        borderRadius: 24,
        boxShadow: "0 4px 24px #e0e7ef",
        backgroundColor: "#FFFFFF",
        marginLeft: "auto",
        marginRight: "auto",
        padding: 36,
      }}
    >
      <h1
        className="modal-title_u"
        style={{
          textAlign: "center",
          marginBottom: 38,
          color: "#6c889c",
        }}
      >
        {id ? isEdit ? "Edit" : "Copy" : "Create"} Project
      </h1>

      <form className="translation_create_form"
        style={{ display: "flex", flexDirection: "column", gap: 24 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        {/* Client SELECT */}
        <div className="row-primary">
          <h2>Client*</h2>
          <div className="w-100">
            <Controller
              name="account_id"
              control={control}
              rules={{
                required: "Please select a client",
                validate: (value) =>
                  value !== null && value !== ""
                    ? true
                    : "Please select a client",
              }}
              render={({ field }) => (
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={filterClients}
                    loadOptions={filteredClientsLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(obj) => {
                      if (obj?.value) {
                        setfilterClients(obj);
                        setSubAccountOptions(mapSubAccountsToOptions(obj?.data?.sub_accounts));
                        setDepartmentOptions(mapDepartmentsToOptions(obj?.data?.departments));
                        setValue("sub_account_id", null);
                        setValue("department_id", null);
                        field.onChange(obj.value);
                        setValue("church_translation", obj?.filters?.church_translation == 1);
                        setValue("temple_recommend", obj?.filters?.temple_recommend == 1);
                        setTempleRecommendLocked(obj?.filters?.temple_recommend_locked == 1);
                      } else {
                        setfilterClients({
                          label: "",
                          value: "",
                        });
                        setSubAccountOptions([]);
                        setDepartmentOptions([]);
                        setValue("sub_account_id", null);
                        setValue("department_id", null);
                        field.onChange(null);
                        setValue("church_translation", false);
                        setValue("temple_recommend", false);
                        setTempleRecommendLocked(false);
                      }
                    }}
                    additional={{
                      page: item?.state?.id ? 2 : 1,
                    }}
                  />
                  {errors?.account_id?.message && (
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.account_id?.message} />
                    </div>
                  )}
                </div>
              )}
            />
          </div>
        </div>

        {/* Client Subaccount */}
        <div className="row-primary">
          <h2>Client Subaccount</h2>
          <Controller
            name="sub_account_id"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <Select
                  name="sub_account_id"
                  options={subAccountOptions}
                  value={
                    subAccountOptions?.find((opt) => field.value === opt.value) || null
                  }
                  onChange={(selectedOption) => { 
                    field.onChange(selectedOption ?? null);
                  }}
                  isClearable
                  isDisabled={!filterClients?.value}
                  styles={{ ...selectCustomStyles }}
                />
              </div>
            )}
          />
        </div>

        {/* Department */}
        <div className="row-primary">
          <h2>Department</h2>
          <Controller
            name="department_id"
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <Select
                  name="department_id"
                  options={departmentOptions}
                  value={
                    departmentOptions.find(
                      (option) => String(option.value) === String(field.value)
                    ) || null
                  }
                  onChange={(selectedOption) => field.onChange(selectedOption ?? null)}
                  isClearable
                  isDisabled={!filterClients?.value}
                  styles={{ ...selectCustomStyles }}
                />
              </div>
            )}
          />
        </div>

        {/* Source Language  */}
        <div className="row-primary">
          <h2>Source Language*</h2>
          <Controller
            name="source_language_id"
            required
            rules={{
              required: "Source language is required",
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={sourcelanguageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setSourceLanguageState(selected);
                      field.onChange(selected ? selected.value : null);
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.source_language_id?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.source_language_id?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* Target Language  */}
        <div className="row-primary">
          <h2>Target Language*</h2>
          <Controller
            name="target_languages"
            required
            rules={{
              required: "Target language is required",
            }}
            control={control}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement="auto"
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected);
                      field.onChange(selected.map((opt) => opt.value));
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.target_languages?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.target_languages?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* REQUESTER */}
        <div className="row-primary">
          <h2>Requestor*</h2>
          <div className="w-100">
            <Controller
              name="requester_name"
              rules={{
                required: "Requestor name is required",
              }}
              control={control}
              render={({ field }) => (
                <input
                  className="input-in type_inp"
                  placeholder="requester name"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors?.requester_name?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.requester_name?.message} />
              </div>
            )}
          </div>
        </div>

        {/* REQUESTOR EMAIL */}
        <div className="row-primary">
          <h2>Requestor Email</h2>
          <div className="w-100">
            <Controller
              // rules={{
              //   required: "Requestor Email is required",
              //   pattern: {
              //     value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              //     message: "Invalid email format",
              //   },
              // }}
              name="requester_email"
              control={control}
              render={({ field }) => (
                <input
                  required={true}
                  placeholder="requester email"
                  className="input-in type_inp"
                  type="email"
                  pattern={/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/}
                  {...field}
                />
              )}
            />
            {Array.isArray(errors?.requester_email)
              ? errors.requester_email.map((error, idx) => (
                <div style={{ marginBottom: 10 }} key={idx}>
                  <ErrorMessage text={error} />
                </div>
              ))
              : errors?.requester_email?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_email?.message} />
                </div>
              )}
          </div>
        </div>

        {/* Phone Field   */}
        <div className="row-primary">
          <h2>Phone Number</h2>
          <div className="w-100">
            <Controller
              name="requester_phone"
              control={control}
              render={({ field }) => (
                <PhoneInput
                  className="input-in type_inp"
                  type="tel"
                  name="phone"
                  placeholder="Phone number"
                  required
                  {...field}
                />
              )}
            />
            {Array.isArray(errors?.requester_phone)
              ? errors.requester_phone.map((error, idx) => (
                <div style={{ marginBottom: 10 }} key={idx}>
                  <ErrorMessage text={error} />
                </div>
              ))
              : errors?.requester_phone?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_phone?.message} />
                </div>
              )}
          </div>
        </div>

        {/* Due Date  */}
        <div className="row-primary">
          <h2>Due Date</h2>
          <Controller
            name="due_date"
            control={control}
            // rules={{
            //   required: "duee date is required",
            // }}
            render={({ field }) => (
              <div style={{ width: "100%" }}>
                <div className="input-image">
                  <input
                    id="due_date"
                    type="date"
                    name="due_date"
                    placeholder="YYYY-MM-DD"
                    {...field}
                    value={field.value ? field?.value : ""}
                    onPaste={(e) => {
                      e.preventDefault(); // Prevent default paste behavior
                      const pastedData = e.clipboardData.getData("text"); // Get pasted text
                      const dateString = moment
                        .utc(pastedData)
                        .format("YYYY-MM-DD");

                      if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
                        field.onChange(dateString);
                      } else {
                        console.warn("Invalid date format");
                      }
                    }}
                    onChange={(e) => {
                      const dateString = moment
                        .utc(e.target.value)
                        .format("YYYY-MM-DD");
                      field.onChange(dateString);
                    }}
                  />
                  <img
                    src="/images/celender.png"
                    alt="celender Icon"
                    className="custom-icon"
                  />
                </div>
                {errors?.due_date?.message && (
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.due_date?.message} />
                  </div>
                )}
              </div>
            )}
          />
        </div>

        {/* Comment */}
        <div className="row-primary">
          <h2>Comment</h2>
          <div className="w-100">
            <Controller
              name="comment"
              // rules={{
              //   required: "Requestor name is required",
              // }}
              control={control}
              render={({ field }) => (
                <textarea
                  className="input-in type_inp"
                  placeholder="Comment"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors?.comment?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.comment?.message} />
              </div>
            )}
          </div>
        </div>

        {/* Subject Matter */}
        <div className="row-primary">
          <h2>Subject Matter</h2>
          <div className="w-100">
            <Controller
              name="subject_matter"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <textarea
                  className="input-in type_inp"
                  placeholder="Subject Matter (optional)"
                  type="text"
                  {...field}
                />
              )}
            />
          </div>
        </div>

       {/* Current Phase */}
        <div className="row-primary">
          <h2>Current Phase</h2>
          <div className="w-100">
            <Controller
              name="current_phase"
              control={control}
              defaultValue=""
              render={({ field }) => {
                return (
                  <div style={{ width: "100%" }}>
                    <Select
                      menuPlacement="auto"
                      styles={{
                        ...selectCustomStyles,
                      }}
                      options={phaseOptions}
                      value={phaseOptions.find((opt) => opt.value === field.value) || null}
                      isClearable
                      escapeClearsValue
                      onChange={(val) => {
                        field.onChange(val ?? "");
                      }}
                    />
                    {errors?.current_phase?.message && (
                      <div style={{ marginBottom: 10 }}>
                        <ErrorMessage text={errors?.current_phase?.message} />
                      </div>
                    )}
                  </div>
                );
              }}
            />
          </div>
        </div>

        {/* Word Count - Translation / Editing / Other */}
        {/* {["translation", "editing" , "audio_recording" , "other", ""].includes(watch("current_phase")) && (
          <div className="row-primary">
            <h2>Word Count*</h2>
            <div className="w-100">
              <Controller
                name="word_count"
                control={control}
                rules={{ required: "Please enter total word count" }}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    type="number"
                    min="0"
                    placeholder="Total word count"
                    {...field}
                  />
                )}
              />
              {errors?.word_count?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.word_count?.message} />
                </div>
              )}
            </div>
          </div>
        )} */}

        {/* Page Count - Review */}
        {/* {watch("current_phase") === "review" && (
          <div className="row-primary">
            <h2>Page Count*</h2>
            <div className="w-100">
              <Controller
                name="page_count"
                control={control}
                rules={{ required: "Please enter number of pages" }}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    type="number"
                    min="1"
                    placeholder="Number of pages to review"
                    {...field}
                  />
                )}
              />
              {errors?.page_count?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.page_count?.message} />
                </div>
              )}
            </div>
          </div>
        )} */}

        {/* Audio Minutes - Transcription / Audio Recording */}
        {/* {["transcription"].includes(watch("current_phase")) && (
          <div className="row-primary">
            <h2>Audio Minutes*</h2>
            <div className="w-100">
              <Controller
                name="audio_minutes"
                control={control}
                rules={{ required: "Please enter audio duration in minutes" }}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    type="number"
                    step="0.1"
                    min="0"
                    placeholder="Audio length in minutes"
                    {...field}
                  />
                )}
              />
              {errors?.audio_minutes?.message && (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.audio_minutes?.message} />
                </div>
              )}
            </div>
          </div>
        )} */}

        {/* Notes */}
        {customPricingEnabled && (
        <div className="row-primary">
          <h2>Notes</h2>
          <div className="w-100">
            <Controller
              name="notes"
              // rules={{
              //   required: "Requestor name is required",
              // }}
              control={control}
              render={({ field }) => (
                <textarea
                  className="input-in type_inp"
                  placeholder="Notes"
                  type="text"
                  {...field}
                />
              )}
            />
            {errors?.notes?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.notes?.message} />
              </div>
            )}
          </div>
        </div>
        )}

        {/* Formatting Check box */}
        <div className="row-primary" style={{ marginBottom: '10px' }}>
          <div
            className="w-100"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <Controller
              name="temple_recommend"
              control={control}
              defaultValue={false}
              render={({ field }) => (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    // cursor: "pointer",
                    cursor: templeRecommendLocked ? "not-allowed" : "pointer",
                    opacity: templeRecommendLocked ? 0.6 : 1,
                    marginBottom: 0,
                  }}
                  onClick={(e) => {
                    if (templeRecommendLocked) e.preventDefault();
                  }}
                >
                  <input
                    id="temple_recommend"
                    type="checkbox"
                    checked={!!field.value}
                    disabled={templeRecommendLocked}
                    // onChange={(e) => field.onChange(e.target.checked)}
                    onChange={(e) => {
                      if (templeRecommendLocked) return;
                      field.onChange(e.target.checked);
                    }}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      width: 44,
                      height: 24,
                      background: !!field.value ? "#1AD598" : "#e0e7ef",
                      borderRadius: 24,
                      position: "relative",
                      transition: "background 0.2s",
                      display: "inline-block",
                      marginRight: 12,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: !!field.value ? 22 : 2,
                        top: 2,
                        width: 20,
                        height: 20,
                        background: "#fff",
                        borderRadius: "50%",
                        boxShadow: "0 1px 4px #b0b8c9",
                        transition: "left 0.2s",
                      }}
                    />
                  </span>
                  <span style={{ fontWeight: 500, color: "#6c889c", fontSize: '14px' }}>
                    Temple Recommend
                  </span>
                </label>
              )}
            />
            {errors?.temple_recommend?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.temple_recommend?.message} />
              </div>
            )}
          </div>
        </div>
        <div className="row-primary" style={{ marginBottom: '10px' }}>
          <div
            className="w-100"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <Controller
              name="formatting"
              control={control}
              defaultValue={false}
              // rules={{
              //   validate: (value) => value === true || "Formatting is required",
              // }}
              render={({ field }) => (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginBottom: 0,
                  }}
                >
                  <input
                    id="formatting"
                    type="checkbox"
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      width: 44,
                      height: 24,
                      background: !!field.value ? "#1AD598" : "#e0e7ef",
                      borderRadius: 24,
                      position: "relative",
                      transition: "background 0.2s",
                      display: "inline-block",
                      marginRight: 12,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: !!field.value ? 22 : 2,
                        top: 2,
                        width: 20,
                        height: 20,
                        background: "#fff",
                        borderRadius: "50%",
                        boxShadow: "0 1px 4px #b0b8c9",
                        transition: "left 0.2s",
                      }}
                    />
                  </span>
                  <span style={{ fontWeight: 500, color: "#6c889c", fontSize: '14px' }}>
                    Formatting/desktop publishing (DTP)?
                  </span>
                </label>
              )}
            />
            {errors?.formatting?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.formatting?.message} />
              </div>
            )}
          </div>
        </div>

        {/* rush Check box */}
        <div className="row-primary" style={{ marginTop: 0 }}>
          <div
            className="w-100"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <Controller
              name="rush"
              control={control}
              defaultValue={false}
              // rules={{
              //   validate: (value) => value === true || "Rush is required",
              // }}
              render={({ field }) => (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    marginBottom: 0,
                  }}
                >
                  <input
                    id="rush"
                    type="checkbox"
                    checked={!!field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    style={{ display: "none" }}
                  />
                  <span
                    style={{
                      width: 44,
                      height: 24,
                      background: !!field.value ? "#1AD598" : "#e0e7ef",
                      borderRadius: 24,
                      position: "relative",
                      transition: "background 0.2s",
                      display: "inline-block",
                      marginRight: 12,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: !!field.value ? 22 : 2,
                        top: 2,
                        width: 20,
                        height: 20,
                        background: "#fff",
                        borderRadius: "50%",
                        boxShadow: "0 1px 4px #b0b8c9",
                        transition: "left 0.2s",
                      }}
                    />
                  </span>
                  <span style={{ fontWeight: 500, color: "#6c889c", fontSize: '14px' }}>
                    Rush/Expedited
                  </span>
                </label>
              )}
            />
            {errors?.rush?.message && (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={errors?.rush?.message} />
              </div>
            )}
          </div>
        </div>

        <div className="row-primary" style={{ marginTop: 0 }}>
          <div
            className="w-100"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                marginBottom: 0,
              }}
            >
              <input
                id="custom_pricing"
                type="checkbox"
                checked={customPricingEnabled}
                onChange={(e) => setValue("custom_pricing", e.target.checked ? 1 : 0)}
                style={{ display: "none" }}
              />
              <span
                style={{
                  width: 44,
                  height: 24,
                  background: customPricingEnabled ? "#1AD598" : "#e0e7ef",
                  borderRadius: 24,
                  position: "relative",
                  transition: "background 0.2s",
                  display: "inline-block",
                  marginRight: 12,
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    left: customPricingEnabled ? 22 : 2,
                    top: 2,
                    width: 20,
                    height: 20,
                    background: "#fff",
                    borderRadius: "50%",
                    boxShadow: "0 1px 4px #b0b8c9",
                    transition: "left 0.2s",
                  }}
                />
              </span>
              <span style={{ fontWeight: 500, color: "#6c889c", fontSize: '14px' }}>
                Custom Pricing
              </span>
            </label>
          </div>
        </div>

        {customPricingEnabled && (
          <div
            className="row-primary"
            style={{ marginTop: 0, display: "flex", flexDirection: "column", gap: 16 }}
          >
            <h3 style={{ margin: 0, color: "#6c889c" }}>Custom Pricing Rates</h3>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                gap: 16,
                width: "100%",
              }}
            >
              {[
                { name: "custom_pricing_translation_rate", label: "Translation rate" },
                { name: "custom_pricing_editing_rate", label: "Editing rate" },
                { name: "custom_pricing_dtp_rate", label: "DTP rate" },
                { name: "custom_pricing_review_rate", label: "Review rate" },
                { name: "custom_pricing_audio_recording_rate", label: "Audio recording rate" },
                { name: "custom_pricing_transcription_rate", label: "Transcription rate" },
              ].map((field) => (
                <div key={field.name}>
                  <h2 style={{ marginBottom: 8, fontSize: 14 }}>{field.label}</h2>
                  <Controller
                    name={field.name}
                    control={control}
                    defaultValue=""
                    render={({ field: inputField }) => (
                      <input
                        className="input-in type_inp"
                        type="number"
                        step="0.01"
                        min="0"
                        placeholder={field.label}
                        value={inputField.value ?? ""}
                        onChange={(e) => inputField.onChange(e.target.value)}
                      />
                    )}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* File upload box at the bottom with drag and drop */}
        <div>
          <Controller
            name="files"
            control={control}
            defaultValue={[]}
            rules={
              !isEdit ?{
              required: "Please upload at least one file",
              validate: (value) =>
                value.length > 0 || "Please upload at least one file",
              } : {}
            }
            render={({ field }) => (
              <div
                onDragEnter={(e) => {
                  handleDrag(e);
                }}
                onDragOver={(e) => {
                  handleDrag(e);
                }}
                onDragLeave={(e) => {
                  handleDrag(e);
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setDragActive(false);
                  if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                    // const filesArr = Array.from(e.dataTransfer.files).filter(
                    //   (file) => file.type.startsWith("image/")
                    // );
                    setSelectedFiles((prev) => {
                      const newFiles = [...prev, ...e.dataTransfer.files];
                      field.onChange(newFiles);
                      return newFiles;
                    });
                  }
                }}
                style={{
                  height: 240,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: dragActive ? "2px solid #1976d2" : "2px dashed #ccc",
                  borderRadius: 8,
                  padding: 32,
                  textAlign: "center",
                  marginTop: 16,
                  marginBottom: 10,
                  background: dragActive ? "#e3f2fd" : "#fafbff",
                  transition: "all 0.2s",
                  position: "relative",
                  outline: dragActive ? "2px solid #1976d2" : "none",
                }}
              >
                <input
                  type="file"
                  ref={inputRef}
                  style={{ display: "none" }}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  multiple
                  onChange={(e) => {
                    if (e.target.files && e.target.files.length > 0) {
                      // const filesArr = Array.from(e.target.files).filter((file) =>
                      //   file.type.startsWith("image/")
                      // );
                      setSelectedFiles((prev) => {
                        const newFiles = [...prev, ...e.target.files];
                        field.onChange(newFiles);
                        return newFiles;
                      });
                      setValue("");
                    }
                  }}
                />
                <div
                  style={{
                    color: "#6F8DFF",
                    fontWeight: 600,
                    fontSize: 22,
                    marginBottom: 16,
                  }}
                >
                  Browse or Drag and Drop{" "}
                  <span
                    style={{
                      color: "#6c889c",
                      fontWeight: 400,
                      fontSize: 18,
                      marginLeft: 12,
                    }}
                  >
                    (.doc, .docx, .pdf, .jpg, .jpeg, .png)
                    {/* (any file type) */}
                  </span>
                </div>
                <SubmitButton
                  btnText="Browse Files"
                  buttonType="button"
                  handleSubmit={handleBrowseClick}
                />
              </div>
            )}
          />
          {errors?.files?.message && (
            <div style={{ color: "red", marginTop: 8 }}>
              {errors.files.message}
            </div>
          )}
        </div>

        {/* Table for selected images */}
        {selectedFiles.length > 0 && (
          <div
            style={{
              marginTop: 4,
              marginBottom: 14,
              borderRadius: 14,
              overflow: "hidden",
              boxShadow: "0 2px 12px #e0e7ef",
              background: "#f8fafc",
              border: "1.5px solid #e0e7ef",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderSpacing: 0,
                background: "#f8fafc",
                fontSize: 15,
                color: "#6c889c",
              }}
            >
              <thead>
                <tr style={{ background: "#f4f7fb" }}>
                  <th
                    style={{
                      padding: "16px 10px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      padding: "16px 8px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                      borderLeft: "1.5px solid #e0e7ef",
                    }}
                  >
                    File
                  </th>
                  <th
                    style={{
                      padding: "16px 8px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                      borderLeft: "1.5px solid #e0e7ef",
                      borderRight: "1.5px solid #e0e7ef",
                    }}
                  >
                    Password (if any)
                  </th>
                  <th
                    style={{
                      padding: "16px 8px",
                      fontWeight: 700,
                      textAlign: "left",
                      color: "#6c889c",
                      borderBottom: "1.5px solid #e0e7ef",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedFiles.map((file, idx) => (
                  <tr
                    key={idx}
                    style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}
                  >
                    <td
                      style={{
                        padding: "14px 8px",
                        textAlign: "center",
                        borderBottom: "1px solid #e0e7ef",
                        borderRight: "1.5px solid #e0e7ef",
                      }}
                    >
                      {idx + 1}
                    </td>
                    <td
                      style={{
                        padding: "14px 8px",
                        borderBottom: "1px solid #e0e7ef",
                        borderRight: "1.5px solid #e0e7ef",
                      }}
                    >
                      {file.name}
                    </td>
                    <td
                      style={{
                        padding: "14px 8px",
                        borderBottom: "1px solid #e0e7ef",
                        borderRight: "1.5px solid #e0e7ef",
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Password"
                        value={filePasswords[idx] || ""}
                        onChange={(e) =>
                          handlePasswordChange(idx, e.target.value)
                        }
                        style={{
                          width: "90%",
                          padding: "10px 14px",
                          border: "1.5px solid #e0e7ef",
                          borderRadius: 8,
                          fontSize: 15,
                          outline: "none",
                          background: "#f8fafc",
                          color: "#6c889c",
                          transition: "border 0.2s, box-shadow 0.2s",
                        }}
                        onFocus={(e) =>
                          (e.target.style.border = "1.5px solid #1976d2")
                        }
                        onBlur={(e) =>
                          (e.target.style.border = "1.5px solid #e0e7ef")
                        }
                      />
                    </td>
                    <td
                      style={{
                        padding: "14px 8px",
                        textAlign: "center",
                        borderBottom: "1px solid #e0e7ef",
                      }}
                    >
                      <span
                        onClick={() => handleRemoveFile(idx)}
                        style={{
                          color: "#d32f2f",
                          cursor: "pointer",
                          fontWeight: 600,
                          textDecoration: "underline",
                          padding: "8px 10px",
                          borderRadius: 6,
                          transition: "background 0.15s",
                          userSelect: "none",
                          display: "inline-block",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.background = "#ffeaea")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                        role="button"
                        tabIndex={0}
                      >
                        <Trash2Icon size={18} />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <SubmitButton
          btnText={isloading ? "loading..." : "Submit »"}
          buttonType="button"
          handleSubmit={handleSubmit(onSubmit)}
          loader={isloading}
        />
      </form>
    </div>
  );
};

export default AddTranslatoinForm;
